/**
 * GraphQL queries for Shopify pages
 */

/**
 * Query to get a page by handle
 */
export const GET_PAGE_BY_HANDLE = `
  query getPageByHandle($handle: String!) {
    page(handle: $handle) {
      body
      bodySummary
      handle
      id
      title
      seo {
        title
        description
      }
    }
  }
`;
